import Homepage from "../../homepage/homepage";

const HomepagePage = () => {
    return <Homepage />;
};

export default HomepagePage;
